import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step5 } from '../../../../../shared/models/component-messages/diveIN/step5';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G1 } from '../../models/TypeAnn_DIVER_G1';
import { TypeDelaisDivers } from '../../models/TypeDelaisDivers';

@Component({
	selector: 'app-step5',
	templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {

	private LOG: LogService = new LogService(Step5Component);

	@Input() initial: TypeAnn_DIVER_G1;
	@Input() delais: TypeDelaisDivers;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() uid = '';

	public step5 = new Step5();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }

	ngOnInit(): void {
	}

	public getUid() {
		return this.uid;
	}

	getUidProcedure(){
		return this.uid + '_SepSep_ChampsLibresTexteDate';
	}

	getUidTxtLibre(){
		return this.getUidProcedure() + '_SepSep_ChampLibreGroup';
	}

	getUidIntLibre(){
		return this.getUidProcedure() + '_SepSep_IntituleLibreGroup';
	}

	getUidDateLibre(){
		return this.getUidProcedure() + '_SepSep_DateLibreGroup';
	}

}
